<template>
  <div class="client_log_page">
    <h1>主播马甲管理 主播列表</h1>
    <div class="user-options clearfix">
      主播rid:
      <el-input v-model="ridStr" style="width: 160px" placeholder=""></el-input>
      素材张数:
      <el-input
        type="number"
        v-model="materialCount"
        style="width: 160px"
        placeholder=""
      ></el-input>
      主播等级:
      <el-select style="width: 160px" v-model="hostLevel" placeholder="">
        <el-option
          v-for="(item, itemIndex) in hostLevels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      国家:
      <el-select
        filterable
        style="width: 160px"
        v-model="countryCode"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      语言:
      <el-select
        filterable
        style="width: 160px"
        v-model="langId"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in languageList"
          v-bind:key="itemIndex + 199"
          :label="item.language"
          :value="item.langCode"
        ></el-option>
      </el-select>

      <el-button type="primary" @click="getDayChatDetai(0)">查询</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <el-table height="60vh" :data="tableList" style="width: 100%" border>
          <el-table-column prop="rid" label="主播rid" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名字" align="center">
          </el-table-column>
          <el-table-column prop="countryCode" label="国家码" align="center">
          </el-table-column>
          <el-table-column prop="language" label="语言" align="center">
          </el-table-column>
          <el-table-column
            width="150px"
            align="center"
            prop="hostLevel"
            label="主播等级"
            sortable
          >
            <template slot-scope="scope">
              {{ 'L' + scope.row.hostLevel }}
            </template>
          </el-table-column>
          <el-table-column
            prop="lastActiveTime"
            label="最近活跃时间"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="materialCount" label="素材数量" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="ridList(scope.row.rid)"
                >查看素材</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="display-type">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="10"
        class="pagination"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <HostVestInfo ref="HostVestInfo" :numRid="numRid"></HostVestInfo>
    </el-dialog>
  </div>
</template>

<script>
import HostVestInfo from './HostVestInfo'
import { getCountryMore, getLanguage_new } from '@/utils/normalApi.js'
export default {
  components: {
    HostVestInfo
  },
  data () {
    return {
      dialogVisible: false,
      page: 1,
      total: 0,
      ridStr: '', // 主播rid
      materialCount: null, // 素材张数
      hostLevel: -1, // 主播等级
      hostLevels: [
        {
          label: 'all',
          value: -1
        },
        {
          label: 'L0',
          value: 0
        },
        {
          label: 'L1',
          value: 1
        },
        {
          label: 'L2',
          value: 2
        },
        {
          label: 'L3',
          value: 3
        }
      ],
      tableList: [],
      countryCode: 'all', // 国家
      countryList: [],
      langId: 'all', // 语言
      languageList: [],
      loading: true,
      numRid: ''
    }
  },
  beforeCreate () {},
  created () {
    this._getCountry()
    this._getLanguage()
    this.getDayChatDetai()
  },
  mounted () {},

  watch: {},
  methods: {
    ridList (rid) {
      this.dialogVisible = true
      setTimeout(() => {
        this.$refs.HostVestInfo.rid = rid
        this.$refs.HostVestInfo.getDayChatDetai()
      }, 100)
    },
    handleClose () {
      this.dialogVisible = false
    },
    handleCurrentChange () {
      this.getDayChatDetai()
    },
    async _getCountry () {
      const res = await getCountryMore()
      if (res !== null) {
        res.countryList.unshift({
          country: 'all',
          countryCode: 'all'
        })
        this.countryList = res.countryList
      }
    },
    async _getLanguage () {
      const res = await getLanguage_new()
      if (res !== null) {
        res.unshift({
          langCode: 'all',
          language: 'all'
        })
        this.languageList = res
      }
    },
    // 查询列表
    async getDayChatDetai (rids) {
      this.loading = true
      let data = {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        page: this.page,
        ridStr: this.ridStr,
        materialCount:
          this.materialCount == null ? -1 : Number(this.materialCount),
        hostLevel: this.hostLevel,
        countryCode: this.countryCode,
        langId: this.langId
      }
      if (rids) {
        data.page = 1
      }

      let url =
        this.$store.getters.path.host_list +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token

      const { data: res } = await this.$axios.post(url, data)
      this.loading = false
      if (res.code != 0) return this.$message(res.msg)
      this.tableList = res.data.data
      this.total = res.data.total
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.client_log_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
